import { render, staticRenderFns } from "./PriceBreakdown.vue?vue&type=template&id=c83b0f60&scoped=true"
import script from "./PriceBreakdown.vue?vue&type=script&lang=js"
export * from "./PriceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./PriceBreakdown.vue?vue&type=style&index=0&id=c83b0f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83b0f60",
  null
  
)

export default component.exports